"use client"

import { motion } from "framer-motion"

export function WhoWeAre() {
  return (
    <section id="mission" className="scroll-mt-24 bg-white py-20">
      <div className="container mx-auto max-w-3xl px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-sm font-semibold uppercase tracking-wider text-blue-600">
            Our mission
          </span>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 md:text-5xl">
            <span className="block leading-tight">Better career choices</span>
            <span className="mt-2 block bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text pb-1 leading-tight text-transparent">
              backed by football and AI
            </span>
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-slate-600">
            SigmAI combines football expertise with an AI platform. You get one clear
            overview of stats, contracts and career planning, so players and agents
            can make better decisions at every stage of a career.
          </p>
        </motion.div>
      </div>
    </section>
  )
}
